'use strict';

var App = App || {},
    yaMapsScriptPath = '//api-maps.yandex.ru/2.1/?lang=ru_RU',
    YaMap;

YaMap = function (element, options) {
    this.element = element;
    this.element.data('map', this);
    this.options = $.extend({
        mapZoom: 17,
        controls: ['smallMapDefaultSet']
    }, options);

    if (!App.mapScript) {
        App.mapScript = true;
        $.getScript(yaMapsScriptPath, function () {
            ymaps.ready(this.initMap.bind(this));
        }.bind(this));
    } else {
        let mapWaiter = setInterval(function () {
            if (typeof ymaps !== 'undefined') {
                ymaps.ready(this.initMap.bind(this));
                clearInterval(mapWaiter);
            }
        }.bind(this), 100)
    }

};

YaMap.prototype.initMap = function () {
    this.address = this.element.data('address') || false;
    this.center = this.element.data('center') || false;

    if (this.center !== false) {
        this.DrawMap(this.center);
    } else if (this.address !== false) {
        this.GeocodeMap(this.address);
    }

    $(window).on('map-set-zoom', this.setZoom.bind(this));
};

YaMap.prototype.DrawMap = function (center) {
    this.map = new ymaps.Map(
        this.element[0], {
            center: center,
            controls: this.options.controls,
            zoom: this.options.mapZoom
        },
        {
            suppressMapOpenBlock: true
        });
    this.map.behaviors.disable('scrollZoom');

    this.element.trigger('loaded');

    if (this.element.data('link')) {
        var objectManager = new ymaps.ObjectManager({
            // Чтобы метки начали кластеризоваться, выставляем опцию.
            clusterize: true,
            clusterDisableClickZoom: false
        });
        objectManager.clusters.options.set({
            gridSize: 64,
            preset: 'islands#orangeClusterIcons',
            balloonContentLayoutWidth: 'auto',
            balloonContentLayoutHeight: 'auto',
            balloonContentLayout: 'cluster#balloonCarousel'
        });
        objectManager.objects.options.set('preset', 'islands#orangeIcon');
        $.ajax({
            url: this.element.data('link')
        }).done(function (data) {
            if (data) {
                objectManager.add(data);
                this.setZoom();
            }
        }.bind(this));
        this.map.geoObjects.add(objectManager)
    } else {
        var myPlaceMark = new ymaps.Placemark(
            center,
            {
                balloonContent: this.address,
                iconCaption: this.element.data('title') || false
            },
            {
                preset: "islands#darkOrangeIcon"
            });

        this.map.geoObjects.add(myPlaceMark);
    }
};

YaMap.prototype.setZoom = function () {
    if (this.map) {
        var bounds = this.map.geoObjects.getBounds();
        if (bounds) {
            this.map.container.fitToViewport();
            this.map.setBounds(bounds, {checkZoomRange: true});
        }
    }
};

YaMap.prototype.GeocodeMap = function (address) {
    ymaps.geocode(address, {results: 1}).then(ymaps.util.bind(function (res) {
        var firstGeoObject = res.geoObjects.get(0);
        this.DrawMap(firstGeoObject.geometry.getCoordinates());
    }, this));
};